import {apiClient} from './axios';
import {
    AdminMissionDto,
    AdminMissionTierDto,
    MissionRewardCostumeDto,
    PatchMissionRequest,
    PatchMissionTierRequest,
} from '../types/mission';

export const missionApi = {
    /** GET /admin/missions → AdminMissionDto[] */
    getAll: async (): Promise<AdminMissionDto[]> => {
        const result = await apiClient.get<AdminMissionDto[]>('/admin/missions');
        return result ?? [];
    },

    /** PATCH /admin/missions/{id} */
    patchMission: (
        id: number,
        body: PatchMissionRequest
    ): Promise<AdminMissionDto> =>
        apiClient.patch<AdminMissionDto>(`/admin/missions/${id}`, body),

    /** PATCH /admin/mission-tiers/{tierId} */
    patchTier: (
        tierId: number,
        body: PatchMissionTierRequest
    ): Promise<AdminMissionTierDto> =>
        apiClient.patch<AdminMissionTierDto>(`/admin/mission-tiers/${tierId}`, body),

    /** GET /admin/missions/reward-costumes */
    getRewardCostumes: async (): Promise<MissionRewardCostumeDto[]> => {
        const result = await apiClient.get<MissionRewardCostumeDto[]>(
            '/admin/missions/reward-costumes'
        );
        return result ?? [];
    },
};
